import { render, staticRenderFns } from "./AddonProductNew.vue?vue&type=template&id=9a8ab046&scoped=true&"
import script from "./AddonProductNew.vue?vue&type=script&lang=js&"
export * from "./AddonProductNew.vue?vue&type=script&lang=js&"
import style0 from "./AddonProductNew.vue?vue&type=style&index=0&id=9a8ab046&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a8ab046",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Globaltask\\Documents\\Happybox Store\\Happybox Site\\src\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9a8ab046')) {
      api.createRecord('9a8ab046', component.options)
    } else {
      api.reload('9a8ab046', component.options)
    }
    module.hot.accept("./AddonProductNew.vue?vue&type=template&id=9a8ab046&scoped=true&", function () {
      api.rerender('9a8ab046', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "BuildABox/components/AddonProductNew.vue"
export default component.exports